/**
 * Mock provider data for intake results. Replace with Medplum/API later.
 */

export interface MockProvider {
  id: string;
  name: string;
  credentials: string;
  headshotUrl: string | null;
  gender: 'male' | 'female';
  specialties: string[];
  format: ('in-person' | 'virtual')[];
  location: string;
  zip: string;
  acceptsInsurance: boolean;
  shortBio: string;
  longBio: string;
  languages: string[];
  takingNewClients?: boolean;
}

export const MOCK_PROVIDERS: MockProvider[] = [
  {
    id: 'p1',
    name: 'Dr. Sarah Chen',
    credentials: 'PhD, LP',
    headshotUrl: '/sample_headshot.png',
    gender: 'female',
    specialties: ['Anxiety', 'Depression', 'Cognitive behavioral therapy (CBT)'],
    format: ['virtual', 'in-person'],
    location: 'San Francisco, CA',
    zip: '94102',
    acceptsInsurance: true,
    shortBio: 'Clinical psychologist with 12 years of experience in anxiety and mood disorders.',
    longBio:
      'Dr. Chen specializes in evidence-based treatments including CBT, mindfulness, and skills-based therapy for anxiety and mood disorders. Her approach is warm, structured, and collaborative—balancing practical tools with space to explore patterns and stressors. She works with adults navigating high-pressure careers, life transitions, relationship concerns, and burnout, and she tailors sessions to your goals while tracking progress over time. Sessions include coping strategies you can practice between visits, and she makes time to review what is (and isn’t) working so the plan stays aligned with you.',
    languages: ['English', 'Mandarin'],
    takingNewClients: true,
  },
  {
    id: 'p2',
    name: 'James Rivera',
    credentials: 'LCSW',
    headshotUrl: '/sample_headshot.png',
    gender: 'male',
    specialties: ['Trauma & PTSD', 'EMDR', 'Trauma-informed'],
    format: ['virtual'],
    location: 'Los Angeles, CA',
    zip: '90012',
    acceptsInsurance: true,
    shortBio: 'Licensed clinical social worker focused on trauma recovery and EMDR.',
    longBio:
      'James provides trauma-informed care and EMDR for adults, with an emphasis on helping clients feel grounded and in control during the healing process. He integrates stabilization skills (sleep, nervous system regulation, and coping strategies) before moving into deeper trauma processing, and he works at a pace that respects your readiness. James is bilingual (English/Spanish) and offers virtual sessions only, supporting clients experiencing PTSD, anxiety, grief, and the impact of complex or ongoing stress. His style is calm, practical, and strengths-based, with clear next steps after each session.',
    languages: ['English', 'Spanish'],
    takingNewClients: true,
  },
  {
    id: 'p3',
    name: 'Dr. Maya Patel',
    credentials: 'PsyD, LMFT',
    headshotUrl: '/sample_headshot.png',
    gender: 'female',
    specialties: ['Couples therapy', 'Family therapy', 'Relationship issues'],
    format: ['in-person', 'virtual'],
    location: 'Oakland, CA',
    zip: '94612',
    acceptsInsurance: true,
    shortBio: 'Couples and family therapist with training in attachment and systems approaches.',
    longBio:
      'Dr. Patel works with couples and families using attachment-informed and systems-based approaches grounded in evidence-based models. She helps clients improve communication, rebuild trust, and navigate recurring conflict patterns—especially around parenting, intimacy, and major life transitions. Sessions focus on practical tools (how to repair after conflict, how to ask for needs, how to set boundaries) while also making space for deeper understanding of relational dynamics. She sees clients in person in Oakland and via telehealth across California, and she welcomes couples at any stage—from new relationships to long-term partnerships seeking renewed connection.',
    languages: ['English'],
    takingNewClients: true,
  },
  {
    id: 'p4',
    name: 'Alex Kim',
    credentials: 'LMFT',
    headshotUrl: '/sample_headshot.png',
    gender: 'male',
    specialties: ['LGBTQ+', 'Anxiety', 'Life transitions'],
    format: ['virtual'],
    location: 'San Diego, CA',
    zip: '92101',
    acceptsInsurance: true,
    shortBio: 'Affirming therapist for LGBTQ+ clients and life transitions.',
    longBio:
      'Alex specializes in LGBTQ+ affirming care, anxiety, and life transitions, offering a supportive space for clients exploring identity, relationships, and belonging. Their work blends practical coping skills with insight-oriented therapy to help you feel more confident navigating change—whether that’s a new job, moving, coming out, or shifting family dynamics. Alex emphasizes collaborative goal-setting and gentle accountability, and sessions often include concrete strategies for reducing overwhelm and improving self-compassion. Virtual sessions are available across California.',
    languages: ['English', 'Korean'],
    takingNewClients: true,
  },
  {
    id: 'p5',
    name: 'Dr. Rachel Green',
    credentials: 'PhD',
    headshotUrl: '/sample_headshot.png',
    gender: 'female',
    specialties: ['Depression', 'ADHD', 'Dialectical behavior therapy (DBT)'],
    format: ['in-person'],
    location: 'Salt Lake City, UT',
    zip: '84101',
    acceptsInsurance: false,
    shortBio: 'Psychologist specializing in DBT and ADHD in adults.',
    longBio:
      'Dr. Green offers DBT and ADHD assessment and treatment for adults, with a focus on building skills that translate into everyday life. Clients often work on emotional regulation, distress tolerance, attention and organization systems, and navigating relationships more effectively. Her approach is structured and practical, with clear exercises to try between sessions and regular check-ins to ensure you’re getting measurable benefit. In-person only in Salt Lake City; self-pay.',
    languages: ['English'],
    takingNewClients: true,
  },
];
